var _rect, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThirdPodium = function SvgThirdPodium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 22,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 22,
    fill: "#0C0C0F",
    fillOpacity: 0.4,
    rx: 8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "third-podium_svg__a",
    width: 16,
    height: 16,
    x: 6,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6 3h16v16H6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#third-podium_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#third-podium_svg__b)",
    d: "M10.928 4.793h6.143v4.743q0 .27-.137.541a1.07 1.07 0 0 1-.384.426l-2.253 1.708.396 1.292h2.11l-1.741 1.226.678 2.133L14 15.54l-1.74 1.322.677-2.138-1.74-1.22h2.11l.395-1.293-2.265-1.695a1.1 1.1 0 0 1-.376-.431 1.2 1.2 0 0 1-.133-.549zm.866.867v3.876a.4.4 0 0 0 .04.185.3.3 0 0 0 .14.123l1.592 1.153V5.66zm4.41 0h-1.771v5.337l1.592-1.153q.117-.051.148-.123a.5.5 0 0 0 .032-.185z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#third-podium_svg__c)",
    d: "M29.132 11.176q.852 0 1.272-.384.432-.396.432-1.008V9.7q0-.66-.42-.984-.408-.336-1.08-.336-.648 0-1.056.288a2.1 2.1 0 0 0-.672.756l-.744-.576q.156-.252.372-.492a2.6 2.6 0 0 1 .528-.444q.3-.192.696-.312t.9-.12q.528 0 .996.144.468.132.804.408.348.264.54.66.204.396.204.9 0 .408-.132.732-.12.324-.336.564t-.516.408q-.288.168-.624.252v.048q.336.072.648.24.324.156.564.42.252.252.396.624.156.36.156.828 0 .54-.204.996a2.3 2.3 0 0 1-.576.768 2.8 2.8 0 0 1-.9.492q-.528.18-1.164.18a3.5 3.5 0 0 1-.96-.12 2.9 2.9 0 0 1-.744-.324 3.3 3.3 0 0 1-.576-.456 4.5 4.5 0 0 1-.432-.528l.756-.576q.156.252.336.456.192.204.42.348t.516.228q.288.072.672.072.888 0 1.344-.396.456-.408.456-1.152V13.6q0-.744-.456-1.14-.456-.408-1.344-.408h-.984v-.876zM36.519 16h-1.008V7.624h3.336q1.104 0 1.716.612.624.612.624 1.764 0 .924-.432 1.524-.42.588-1.248.78L41.427 16h-1.14l-1.812-3.6H36.52zm2.328-4.464q.6 0 .924-.312.336-.312.336-.888v-.624q0-.576-.336-.888-.324-.312-.924-.312H36.52v3.024zm5.54-3.912h2.808q.78 0 1.416.264t1.08.792q.456.516.696 1.308.24.78.24 1.824t-.24 1.836q-.24.78-.696 1.308a2.84 2.84 0 0 1-1.08.78 3.7 3.7 0 0 1-1.416.264h-2.808zm2.808 7.488q.516 0 .948-.168a2.1 2.1 0 0 0 .744-.516q.312-.336.48-.816.18-.492.18-1.116v-1.368q0-.624-.18-1.104a2.3 2.3 0 0 0-.48-.828 2 2 0 0 0-.744-.504 2.4 2.4 0 0 0-.948-.18h-1.8v6.6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "third-podium_svg__b",
    x1: 14,
    x2: 14,
    y1: 4.793,
    y2: 16.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "third-podium_svg__c",
    x1: 39,
    x2: 39,
    y1: 2,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632E00"
  })))));
};
export default SvgThirdPodium;